/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_421Inputs */

const cs_ares_legal_form_421 = /** @type {(inputs: Ares_Legal_Form_421Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odštěpný závod`)
};

const en_ares_legal_form_421 = /** @type {(inputs: Ares_Legal_Form_421Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch plant`)
};

/**
* | output |
* | --- |
* | "Branch plant" |
*
* @param {Ares_Legal_Form_421Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_421 = /** @type {((inputs?: Ares_Legal_Form_421Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_421Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_421(inputs)
	return cs_ares_legal_form_421(inputs)
});